import { useCallback } from 'react';
import SquareOutlinedIcon from '@mui/icons-material/SquareOutlined';
import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import PropTypes from 'prop-types';

const MaximizeWindow = ({ maximizeHandler }) => {
    const handleClick = useCallback(
        (e) => {
            e.stopPropagation();
            maximizeHandler();
        },
        [maximizeHandler]
    );

    return (
        <Tooltip title="Maximize [Alt + ↑]">
            <IconButton sx={{ padding: '0.25rem' }} aria-label="maximize" onClick={handleClick}>
                <SquareOutlinedIcon sx={{ width: '1.25rem', height: '1.25rem', color: '#fff' }} />
            </IconButton>
        </Tooltip>
    );
};

MaximizeWindow.prpTypes = {
    minimizeHandler: PropTypes.func.isRequired,
};

export default MaximizeWindow;
